import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';

import { AppTheme } from '../../styles/AppTheme';
import { CommonStyles } from '../../styles/Styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Controller } from '../../common/Controller';
import { AppConfig } from '../../AppConfig'
import { AppHelper } from '../../helpers/AppHelper';

export class DrawerMenu extends Component {
  constructor(props) {
    super(props);
    /*this.logout = {
      key: 'logout',
      link: '/login',
      title: 'Logout'
    }*/
    this.appUser = Controller.get().userMgr().getAppUser();
  }

  onLinkClick = (pathname, key) => {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 0)
    if (key === 'customize') {
      // Controller.get().pushRouteWithParams(pathname, { indexKey: 'preferedQSections' });
    } else {
      Controller.get().pushRoute(pathname);
    }
    /*if (pathname !== '/profile') {
      window.location.reload()
    }*/
  }

  logOut = () => {
    Controller.get().logout()
    window.location.reload()
  }

  onMenuItemClick = (key, path) => {
    if (key === 'logout') {
      this.logOut()
    } else {
      this.onLinkClick(path, key)
    }
  }

  navLinkRouteV2 = (key, path, title) => {
    return (
      <div
        key={key}
        className={css(CommonStyles.link)}
        onClick={() => this.onMenuItemClick(key, path)}
      >
        <ListItem
          button
          onClick={this.props.onClose}
          className={css(Styles.listItemContainer)}
        >
          <ListItemText
            classes={{
              root: css(Styles.listItemRoot),
              primary: css(Styles.listItem)
            }}
          >
            {title}
          </ListItemText>
        </ListItem>
      </div>
    )
  }

  /*navLinkRoute = (item) => {
    return (
      <div
        key={item.id}
        className={css(CommonStyles.link)}
        onClick={() => this.onLinkClick('/survey-sections/' + item.id)}
      >
        <ListItem
          button
          onClick={this.props.onClose}
          className={css(Styles.listItemContainer)}
        >
          <ListItemText
            classes={{
              root: css(Styles.listItemRoot),
              primary: css(Styles.listItem)
            }}
          >
            {item.title}
          </ListItemText>
        </ListItem>
      </div>
    )
  }*/

  /*navLogOutRoute = (item) => {
    return (
      <Link
        key={item.id}
        to={{ pathname: item.link }}
        className={css(CommonStyles.link)}
        onClick={() => this.logOut()}
      >
        <ListItem button
          onClick={this.props.onClose}
          className={css(Styles.listItemContainer, Styles.listItemContainerApp)}
        >
          <div className={css(Styles.listItem, Styles.listItemAppDetails)}>
            {item.title}
          </div>
        </ListItem>
      </Link>
    )
  }

  navProfileRoute = (key, path, title) => {
    return (
      <div
        key={key}
        className={css(CommonStyles.link)}
        onClick={() => this.onLinkClick(path, key)}
      >
        <ListItem button
          onClick={this.props.onClose}
          className={css(Styles.listItemContainer, Styles.listItemContainerApp)}
        >
          <div className={css(Styles.listItem, Styles.listItemAppDetails)}>
            {title}
          </div>
        </ListItem>
      </div>
    )
  }

  navRoute = (key, path, title) => {
    return (
      <Link
        key={key}
        to={{ pathname: path }}
        className={css(CommonStyles.link)}
      >
        <ListItem button
          onClick={this.props.onClose}
          className={css(Styles.listItemContainer, Styles.listItemContainerApp)}
        >
          <div className={css(Styles.listItem, Styles.listItemAppDetails)}>
            {title}
          </div>
        </ListItem>
      </Link>
    )
  }*/

  appDetail = (item) => {
    return (
      <ListItem className={css(Styles.listItemContainer, Styles.listItemContainerApp)} >
        <div className={css(Styles.listItem, Styles.listItemAppDetails)}>
          {item}
        </div>
      </ListItem>
    )
  }


  renderList() {
    const appUser = Controller.get().userMgr().getAppUser();
    return (
      <div className={css(Styles.listContainer)}>
        <List className={css(Styles.listItemHeader)}>
          Menu
        </List>
        <List className={css(Styles.listItemHeader, Styles.listItemApp)}>
          {this.appUser &&
            this.appDetail(this.appUser.email)}
          {this.appDetail('Version ' + AppConfig.Version)}
          {/*{this.navLogOutRoute(this.logout)}
          {this.navProfileRoute('profile', '/profile', 'My Profile')}
          {this.navRoute('home', AppConfig.clientDashboard, 'Home')}*/}
        </List>
        <List>
          {this.navLinkRouteV2('home', AppConfig.clientDashboard, 'Home')}
          {this.navLinkRouteV2('profile', '/profile', 'My Profile')}
          {/* {this.navLinkRouteV2('customize', '/profile', 'Customize')} */}
          {this.navLinkRouteV2('logout', '/login', 'Logout')}
        </List>
        {/*<List>
          {this.props.items.map(item => {
            return (
              this.navLinkRoute(item)
            )
          })}
        </List>*/}
      </div>
    )
  }

  render() {
    return (
      <SwipeableDrawer
        anchor='right'
        open={this.props.open}
        onClose={this.props.onClose}
        onOpen={this.props.onOpen}
        className={css(Styles.swipe)}
        classes={{
          paper: css(Styles.drawerPaper),
        }}
      >
        {this.renderList()}
        {AppHelper.getCopyrightString()}
      </SwipeableDrawer>
    );
  }
}

const Styles = StyleSheet.create({
  drawerPaper: {
    minWidth: 350,
    background: AppTheme.secondaryBg + '0% 0% no-repeat padding-box',
    visibility: 'visible',
    display: 'flex',
    boxShadow: '2px 2px 3px #B5B5B5',
    border: '3px solid #EEEEEE',
    borderRadius: '50px 0px 0px 50px',
    '@media (max-width: 767px)': {
      minWidth: 175,
      borderRadius: '30px 0px 0px 30px',
    }
  },
  listContainer: {
    flex: 1
  },
  listItemHeader: {
    fontSize: 45,
    textAlign: 'center',
    padding: '30px 0px',
    borderRadius: '50px 0px 0px 50px',
    '@media (max-width: 767px)': {
      fontSize: 30,
      padding: '20px 0px',
      paddingRight: 35
    }
  },
  listItemApp: {
    padding: '0px 0px 30px 0px',
    '@media (max-width: 767px)': {
      padding: '0px 0px 20px 0px',
    }
  },
  listItemContainer: {
    textAlign: 'center',
    padding: 0,
    marginBottom: 10,
    '@media(max-width: 767px)': {
      padding: '0px 10px'
    },
    ':hover': {
      background: 'transparent'
    }
  },
  listItemContainerApp: {
    marginBottom: 5,
    display: 'flex',
    justifyContent: 'center'
  },
  listItemRoot: {
    margin: 0,
    '@media (max-width: 767px)': {
      marginRight: 20
    }
  },
  listItem: {
    color: AppTheme.primaryColor,
    fontSize: 30,
    '@media(max-width: 767px)': {
      fontSize: 20,
    }
  },
  listItemAppDetails: {
    fontSize: 20,
    color: AppTheme.textColorVariant,
    margin: 0,
    '@media (max-width: 767px)': {
      marginRight: 20,
      fontSize: 15,
    }
  }
})


// WEBPACK FOOTER //
// ./src/common/components/DrawerMenu.js